<script>
import colors from '@/modules/cells/colors'
import { $axios } from '@/modules/http/axios'
import emitter from '@/modules/events/emitter'
import eventKinds from '@/modules/events/eventKinds'

export default {
  name: 'DriverCellColorPicker',
  props: ['driver'],
  data () {
    return {
      colors: colors
    }
  },
  methods: {
    async updateCellColor (key = 'text', value) {
      const textColor = key === 'text' ? value : this.driver.textColor
      const backgroundColor = key === 'background' ? value : this.driver.backgroundColor
      const putData = { textColor: textColor, backgroundColor: backgroundColor }

      await $axios.put(`Driver/${this.driver.id}`, putData)
      emitter.emit(eventKinds.driverColorChanged)
    },
  }
}
</script>

<template>
  <div class="text-sm mt-2 user-select-none" role="button">
    Kolor czcionki
    <div>
      <div
        v-for="(color, index) in colors"
        :key="index"
        class="mx-1 px-1 d-inline border border-1"
        role="button"
        :style="`background-color: ${color};`"
        @click="updateCellColor('text', color)"></div>
    </div>
  </div>
  <div class="text-sm mt-2 user-select-none">
    Kolor komórki
    <div>
      <div
        v-for="(color, index) in colors"
        :key="index"
        class="mx-1 px-1 d-inline border border-1"
        role="button"
        :style="`background-color: ${color};`"
        @click="updateCellColor('background', color)"></div>
    </div>
  </div>
</template>
